import React, { useEffect, useRef } from 'react';
import { Toast } from 'bootstrap';
import { ToastMessage, ToastMessageType } from '../model/ToastMessage';

const ToastContainer = ({ messages }: Props) => {
  const refs = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    for(const ref of refs.current) {
      if(ref) {
        const toast = Toast.getOrCreateInstance(ref, {});
        toast.show();
      }
    }
  }, [ messages ]);

  return (
    <div className="toast-container position-fixed top-0 end-0 p-3">
      {
        messages.map((message, i) => <div key={message.message} ref={e => e && (refs.current[i] = e)} className={`toast mb-2 bg-${message.type}-subtle text-${message.type}`} role="alert" data-bs-autohide={message.delay === undefined || message.delay > 0} data-bs-delay={message.delay !== undefined ? message.delay : 5000} aria-live="assertive" aria-atomic="true">
          <div className={`toast-header d-flex align-items-center bg-${message.type}-subtle text-${message.type}`}>
            <div className="avatar flex-shrink-0 avatar-xs me-2">
              <span className={`avatar-initial rounded bg-${message.type}`}>
                <i className={`text-white ti ti-xs ${message.type === ToastMessageType.success ? 'ti-circle-check' : 'ti-alert-circle'}`}></i>
              </span>
            </div>
            <small className="flex-grow-1 fw-bold">{message.title}</small>
            <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
          <div className="toast-body d-flex align-items-center">
            <div className="flex-grow-1">{message.message}</div>
          </div>
        </div>)
      }
    </div>
  );
}

interface Props {
  messages: ToastMessage[]
}

export { ToastContainer };